<template>
  <div id="layout">
    <header id="szjz-cms-header" ref="header">
      <div class="container">
        <!-- <el-dropdown placement="bottom" trigger="click">
          <span class="el-dropdown-link">
            <i class="el-icon-menu"></i>
        </span>-->
        <!-- <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><router-link to="/"><span>首页</span></router-link></el-dropdown-item>
            <el-dropdown-item><router-link to="/product"><span>产品方案</span></router-link></el-dropdown-item>
            <el-dropdown-item><router-link to="/cloud/1"><span>云服务</span></router-link></el-dropdown-item>
            <el-dropdown-item><router-link to="/case/1"><span>客户案例</span></router-link></el-dropdown-item>
            <el-dropdown-item><router-link to="/about/1"><span>关于金政</span></router-link></el-dropdown-item>
        </el-dropdown-menu>-->
        <!-- </el-dropdown> -->
        <router-link to="/">
          <img src="~imgs/home/1.png" alt class="logo" />
        </router-link>
        <div class="wrapper" style="font-weight: bold">
          <nav>
            <router-link
              :class="{
                active: $route.name === 'home' || $route.meta.parent === 'home',
              }"
              to="/"
              @mouseenter.native="onMouseEnter(0)"
            >
              <span>首页</span>
            </router-link>
            <router-link
              :class="{
                active:
                  $route.name === 'product' || $route.meta.parent === 'product',
              }"
              to="/product"
              @mouseenter.native="onMouseEnter(1)"
            >
              <span>产品</span>
            </router-link>
            <router-link
              :class="{
                active: $route.name === 'case' || $route.meta.parent === 'case',
              }"
              to="/case/1"
              @mouseenter.native="onMouseEnter(3)"
            >
              <span>方案</span>
            </router-link>
            <router-link
              :class="{ active: $route.name === 'cloud' }"
              to="/cloud/1"
              @mouseenter.native="onMouseEnter(2)"
            >
              <span>服务</span>
            </router-link>
            <router-link
              :class="{ active: $route.name === 'about' }"
              to="/about/1"
              @mouseenter.native="onMouseEnter(4)"
            >
              <span>关于金政</span>
            </router-link>
            <router-link
              :class="{ active: $route.name === 'cooperation' }"
              to="/cooperation"
              @mouseenter.native="onMouseEnter(5)"
            >
              <span>我想合作</span>
            </router-link>
          </nav>
          <!-- <div class="block" ref="block"></div> -->
        </div>
        <!-- </div> -->
        <div class="menulist">
          <transition name="fade">
            <div
              class="product"
              v-if="hover === 1"
              @mouseenter="onMouseEnter(1)"
              @mouseleave="onMouseLeave(1)"
            >
              <div class="left">
                <div class="header">财政产品</div>
                <div class="wrapper">
                  <dl>
                    <dd>
                      <router-link to="/product-detail/1"
                        >项目库管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/2"
                        >中期财政规划系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/3"
                        >预算编制管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/4"
                        >预算编制调整系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/5"
                        >预算执行管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/6"
                        >预算绩效管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/7"
                        >财务管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/8"
                        >政府采购管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/9"
                        >一企一情管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/10"
                        >财政大数据应用系统</router-link
                      >
                    </dd>
                  </dl>
                  <dl>
                    <dd>
                      <router-link to="/product-detail/11"
                        >资产管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/12"
                        >基建资金管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/13"
                        >专项资金管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/14"
                        >人事工资管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/15"
                        >会计人员网上办事系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/16"
                        >三资监管系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/product-detail/17"
                        >银企互联系统</router-link
                      >
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="content">
                <div class="header">单位内控产品</div>
                <div class="wrapper">
                  <dl>
                    <dd>
                      <router-link to="/solution/1"
                        >项目库管理系统（单位）</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/solution/2"
                        >预算编制管理系统（单位）</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/solution/3"
                        >资产管理系统（单位）</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/solution/4"
                        >预算绩效管理系统（单位）</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/solution/5"
                        >指标管理系统（单位）</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/solution/6"
                        >网上报账系统（单位）</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/solution/7"
                        >财务管理系统（单位）</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/solution/8"
                        >采购管理系统（单位）</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/solution/9"
                        >合同管理系统（单位）</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/solution/10"
                        >人事工资管理系统（单位）</router-link
                      >
                    </dd>
                  </dl>
                  <dl>
                    <dd>
                      <router-link to="/solution/11"
                        >基建资金管理系统（单位）</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/solution/12">文档管理系统</router-link>
                    </dd>
                    <dd>
                      <router-link to="/solution/13"
                        >移动非税收入缴费系统</router-link
                      >
                    </dd>
                  </dl>
                </div>
              </div>
              <div class="right">
                <div class="header">行业应用产品</div>
                <div class="wrapper">
                  <dl>
                    <dd>
                      <router-link to="/application/1"
                        >教育奖补资金管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/application/2"
                        >教育资金监管系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/application/3"
                        >教育事业统计信息管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/application/4"
                        >教育督导评估系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/application/5"
                        >审计管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/application/6"
                        >安监档案管理系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/application/7"
                        >食堂微信收费系统</router-link
                      >
                    </dd>
                    <dd>
                      <router-link to="/application/8"
                        >物业收费管理系统</router-link
                      >
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="menulist2">
          <transition name="fade2">
            <div
              class="product2"
              v-if="hover === 2"
              @mouseenter="onMouseEnter(2)"
              @mouseleave="onMouseLeave(2)"
            >
              <div class="product2-block">
                <div class="right2">
                  <div class="header">服务</div>
                  <div class="wrapper">
                    <dl>
                      <dd>
                        <router-link to="/cloud/1">内控咨询服务</router-link>
                      </dd>
                      <dd>
                        <router-link to="/cloud/2">IT运维服务</router-link>
                      </dd>
                      <dd>
                        <router-link to="/cloud/3">财务增值服务</router-link>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="menulist2">
          <transition name="fade2">
            <div
              class="product2"
              v-if="hover === 3"
              @mouseenter="onMouseEnter(3)"
              @mouseleave="onMouseLeave(3)"
            >
              <div class="product3-block">
                <div class="right3">
                  <div class="header">方案</div>
                  <div class="wrapper">
                    <dl>
                      <dd>
                        <router-link to="/case/1">解决方案</router-link>
                      </dd>
                      <dd>
                        <router-link to="/case/2">客户案例</router-link>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="menulist2">
          <transition name="fade2">
            <div
              class="product2"
              v-if="hover === 4"
              @mouseenter="onMouseEnter(4)"
              @mouseleave="onMouseLeave(4)"
            >
              <div class="product4-block">
                <div class="right4">
                  <div class="header">关于</div>
                  <div class="wrapper">
                    <dl>
                      <dd>
                        <router-link to="/about/1">关于金政</router-link>
                      </dd>
                      <dd>
                        <router-link to="/about/2">合作伙伴</router-link>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </header>
    <router-view ref="view" class="szjz-main-view"></router-view>
    <footer id="szjz-cms-footer">
      <el-row>
        <el-col>
          <div class="container">
            <el-row type="flex" justify="space-around">
              <el-col :span="10">
                <div class="info">
                  <div class="item">
                    <p>
                      <span>服务热线</span>
                    </p>
                    <span>0755-83632007</span>
                  </div>
                  <div class="copyright">
                    2004-{{ new Date().getFullYear() }} ©
                    深圳市金政软件技术有限公司
                    <a
                      href="http://beian.miit.gov.cn/"
                      style="color: #bbb; text-decoration: underline"
                      target="_blank"
                      >粤ICP备15080993号</a
                    >
                  </div>
                </div>
              </el-col>
              <el-col :span="10">
                <div>
                  <router-link to="/cooperation">
                    <el-button class="btn-item" type="text">我想合作</el-button>
                  </router-link>
                </div>

                <div class="address">
                  地址：深圳市龙岗区坂田天安云谷二期4栋505-512
                  <br />邮编：518129
                </div>
              </el-col>
              <el-col :span="4">
                <div class="qrcode">
                  <div class="imgs-2"></div>
                  <div class="txt-g">关注微信公众号</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </footer>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      hover: -1,
      // typeList: [],
      // typeList2: []
    };
  },
  methods: {
    onMouseEnter(index) {
      if (this.$isMobile) return;
      this.hover = index;
    },
    onMouseLeave(index) {
      this.hover = -1;
    },
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        const active = document.querySelector("#szjz-cms-header .active");
        this.$refs.block.style.width = active.offsetWidth + "px";
        this.$refs.block.style.left = active.offsetLeft + "px";
      });
    },
  },
  mounted() {
    const active = document.querySelector("#szjz-cms-header .active");
    this.$refs.block.style.width = active.offsetWidth + "px";
    this.$refs.block.style.left = active.offsetLeft + "px";
    this.init();
  },
};
</script>

<style scoped></style>
